import React from 'react';
import { WLLSFileUpload } from './WLLSFileUpload';
import { WLLSFilesList } from './WLLSFilesList';

interface WLLSUploadTabProps {
  onFileUploaded: (fileId: string) => void;
  onFileSelected: (fileId: string) => void;
  onFileDeleted: (fileId: string) => void;
  refresh: number;
}

export const WLLSUploadTab: React.FC<WLLSUploadTabProps> = ({
  onFileUploaded,
  onFileSelected,
  onFileDeleted,
  refresh
}) => {
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="space-y-6">
        <WLLSFileUpload onFileUploaded={onFileUploaded} />
      </div>
      <div>
        <WLLSFilesList
          onFileSelected={onFileSelected}
          onFileDeleted={onFileDeleted}
          refresh={refresh}
        />
      </div>
    </div>
  );
};